import styled from 'styled-components';

export const Container = styled.div`
  .modal-copy-to-clipboard-message {
    margin-bottom: 1rem;
    text-align: center;
    font-weight: 700;
    color: var(--gray_medium_bold);
  }

  .modal-copy-to-clipboard-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 36rem;
    border-radius: 0.2rem;
    border: 1px solid var(--primary_color);
    border-width: 1.5px;
    padding: 0.6rem 1rem;
    gap: 1rem;
  }

  .modal-copy-to-clipboard-link span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--gray);
  }

  .modal-copy-to-clipboard-link button {
    margin-top: 0;
    font-style: normal;
  }
`;
